module.exports = __webpack_public_path__ + "media/images/brussels/offers/digital-voucher@2x-61084b85be8a252fcb004119aab865f0.jpg";